import React from 'react';
import '../../styles/ImageComponent.css';

type ImageComponentProps = {
  src: string;
  alt?: string;
  center?: boolean;
  style?: React.CSSProperties; // ✅ optional style prop
};

const ImageComponent: React.FC<ImageComponentProps> = ({ src, alt = 'Image', center = false, style }) => {
  return (
    <div className={`image-wrapper ${center ? 'center' : ''}`}>
      <img src={src} alt={alt} className="image" style={style} />
    </div>
  );
};

export default ImageComponent;

